import { ANIMAL_GET } from "../types/animal-types";
export const setAnimal = animal => ({ payload: animal, type: ANIMAL_GET }) 